// extracted by mini-css-extract-plugin
export default {"fullscreenToast":"Toast_fullscreenToast__ln+VY","text":"Toast_text__82DOJ","fadeText":"Toast_fadeText__4p-0C","icon":"Toast_icon__AXpOh","fade":"Toast_fade__IsJsI"};